<img src="{{actualImage}}" class="img-fluid" style="margin-top: 40px;" alt="volta">